import mejores_precios from './MejorasPrecios';

export default angular.module('contartemx.inicio.confirmacion', [
  'contartemx',
  'ui.router',
  'ui.bootstrap',
  'servicios',
  'contartemx.inicio.mejoras_precios'
]).controller('DatosCompraCtrl', [
  '$scope',
  '$state',
  '$stateParams',
  '$location',
  'mostrarNotificacion',
  'callToWebService',
  'ContarteApi',
  'ComprasService',
  function DatosCompraController($scope, $state, $stateParams, $location, mostrarNotificacion, callToWebService, ContarteApi, ComprasService) {
      var referenceCode = $stateParams.referenceCode;
      var opStatus = $stateParams.status;

      //En caso de tener estos dos datos, estamos siendo accedidos desde paypal
      if (referenceCode && opStatus) {
          if (opStatus != "success") {
              mostrarNotificacion.error('No se pudo realizar el pago via paypal');
          }
      } else {
          $scope.EsMembresia = false;
          if (!ComprasService.getTipoCompra()) {
              $location.path("/Inicio/MejorasPrecios/");
              return;
          }
      }

      if (ComprasService.getTipoCompra() == "membresia") {
          $scope.descripcionProducto = "Membresía";
          $scope.EsMembresia = true;
      }
      else if (ComprasService.getTipoCompra() == "timbres") {
          $scope.descripcionProducto = "Paquete de timbres";
          $scope.EsMembresia = false;
      }

      $scope.tipoDeCompra = ComprasService.getTipoCompra();
      $scope.articulo = ComprasService.getArticulo();

      callToWebService.postCall("ObtenerPantallaDatosDeCompra", {}, function success(data) {
          if (!data.EsError && data.Respuesta) {
             $scope.direccion = data.Respuesta.Direccion;
             $scope.calle = data.Respuesta.Direccion.Calle + " " + data.Respuesta.Direccion.Numero + " " + data.Respuesta.Direccion.Colonia;
             $scope.ciudad = $scope.direccion.Ciudad;
             $scope.estado = $scope.direccion.EstadoNombre;
             $scope.pais = $scope.direccion.Pais;
             $scope.bancos = data.Respuesta.Bancos;
          }
      });

      $scope.llamadoDePago = function (esPaypal) {
        $scope.loadingMsg = '';
        $scope.load = true;
          var datos = {
              TipoDeProducto: $scope.tipoDeCompra,
              ClaveProducto: $scope.EsMembresia ? $scope.articulo.ContarteMembershipId : $scope.articulo.TimbrePackageId
          };
          if (esPaypal) {
              callToWebService.postCall("RegistrarOrdenDeCompraPayPal", datos, function success(data) {
                  if (!data.EsError && data.Respuesta) {
                      window.location.replace(data.Respuesta);
                  } else {
                      if (data.Mensaje){
                          $scope.load = false;
                          mostrarNotificacion.error(data.Mensaje);
                        }
                      else{
                          $scope.load = false;
                          mostrarNotificacion.error('No se pudo registrar el pago via paypal');
                        }
                  }
              });
          } else {
              ComprasService.setTipoPago("SPEI");
              callToWebService.postCall("RegistrarOrdenDeCompraSPEI", datos, 
                function success(data) {
                  if (!data.EsError && data.Respuesta) {
                      $scope.load = false;
                      $state.transitionTo('inicio.confirmacion', { referenceCode: data.Respuesta, paymentType: "SPEI" });
                  } else {
                      $scope.load = false;
                      if (data.Mensaje)
                          mostrarNotificacion.error(data.Mensaje);
                      else
                          mostrarNotificacion.error('No se pudo registrar el pago via SPEI');;
                  }
              });
          }
      };
  }
]).controller('ConfirmacionCtrl', [
    '$scope',
    '$location',
    '$stateParams',
    'callToWebService', 
    'ContarteApi', 
    'ComprasService',
    function ConfirmacionController($scope, $location ,$stateParams, callToWebService, ContarteApi, ComprasService) {
        // "Paypal" | "SPEI"
        $scope.referencia = $stateParams.referenceCode;

        $scope.TipoPago = $stateParams.paymentType;
        $scope.esPagoSpei = $scope.TipoPago == "SPEI";

      if (!$scope.referencia) {
          $location.path("/Inicio/MejorasPrecios/");
          return;
      }

      

      var datosParaEnviar = { referencia: $scope.referencia };

      if($scope.esPagoSpei) {
        callToWebService.postCall("ObtenerPantallaDatosDeCompra", {}, function success(data) {
          if (!data.EsError && data.Respuesta) {
             $scope.direccion = data.Respuesta.Direccion;
             $scope.calle = data.Respuesta.Direccion.Calle + " " + data.Respuesta.Direccion.Numero + " " + data.Respuesta.Direccion.Colonia;
             $scope.ciudad = $scope.direccion.Ciudad;
             $scope.estado = $scope.direccion.EstadoNombre;
             $scope.pais = $scope.direccion.Pais;
             $scope.bancos = data.Respuesta.Bancos;
          }
        });

      }

      callToWebService.postCall("ObtenerPantallaConfirmacionCompra", datosParaEnviar, function success(data) {
        if (data.Respuesta && !data.Respuesta.EsError) {
          for(var i in data.Respuesta.Conceptos) {
            var concepto = data.Respuesta.Conceptos[i];
            concepto.Descripcion = getProductDescription(concepto.Tipo);
          }
          $scope.reciboDeCompra = data.Respuesta;
        }
      });

      function getProductDescription(productType) {
        if(productType == 'membresia')
          return 'Membresía';
        else if(productType = 'timbres')
          return 'Paquete de Timbres'
      }
    }
]);
